import React, { useContext, useEffect, useState } from "react";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { TextField } from "@mui/material";
import Button from '@mui/material/Button';
import logo from '../../contract.png'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { AppContext } from "../../App";
import Clause from "./Clause";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import IconButton from '@mui/material/IconButton';
import ContractOpen from "./contractOpen";
import {Typography} from "@mui/material";

export default function ContractTemplate(){

  const {activeUser, setChangesMade} = useContext(AppContext)

  const clauses = activeUser.contractClauses

  const [open, setOpen] = useState(false);

  const [addClause, setAddClause] = useState({
    heading: "",
    content: ""
  })

  async function deleteClause(e, heading){
    e.preventDefault()
    const user = localStorage.getItem("user")

    await fetch(`https://the-paper-pusher.herokuapp.com/deleteClause/${user}/${heading}`,{
      method: 'POST'
    })
    setChangesMade(prev => prev+1)
  }

  const handleChange = (e) => {
    setAddClause({
      ...addClause,
      [e.target.name]: e.target.value
    })
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };


  async function newClauseToDB(e) {
    e.preventDefault()
    const newClause = {...addClause}
    const user = localStorage.getItem("user")

    await fetch(`https://the-paper-pusher.herokuapp.com/updateContract/${user}`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(newClause)
    })
    .catch(error=>{
      window.alert(error)
      return
    })
    setChangesMade(prev => prev+1)
    handleClose()
  }


  return (
    <div className="contract-template">
      <h3>Contract Template</h3>  
      <Paper elevation={3}>
        <img src={logo} alt="tutus-logo" className='contract-logo' />
        <ContractOpen />
        <TableContainer >
          <Table>
            <TableBody>
              {clauses.map((clause, index) => (
                <TableRow key={index} sx={{display: 'flex', width: "100%"}}>
                  <TableCell key={index} sx={{maxWidth: "100px", alignSelf: 'bottom', fontWeight: 700}}>{clause.heading}</TableCell>
                  <TableCell sx={{padding: 'none'}} >
                    <Clause 
                      key={index}
                      index={index} 
                      defValue={clause.content}
                      delFunc={(e)=>deleteClause(e, clause.heading)}
                      />
                  </ TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </ TableContainer>
        <IconButton onClick={handleClickOpen}><AddCircleOutlineIcon /><Typography sx={{marginLeft: '0.3em', marginTop: '0.3em', }}>add clause</Typography></IconButton>
              <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Add New Clause</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    Please enter the details of your new clause:
                  </DialogContentText>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="newclause"
                    label="Heading"
                    type="text"
                    fullWidth
                    name="heading"
                    onChange={handleChange}
                  />
                  <TextField
                    multiline
                    margin="dense"
                    id="newclausecontent"
                    label="Content"
                    type="text"
                    fullWidth
                    name="content"
                    minRows={3}
                    onChange={handleChange}
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose}>Cancel</Button>
                  <Button onClick={newClauseToDB}>Add</Button>
                </DialogActions>
            </Dialog>
      </Paper>
    </div>
  )
}